import {
  LOGIN_LOADING,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  SIDEBAR_COLLAPSE,
  SET_SHOP_INFO,
  SET_MERCHANT_INFO,
  SET_CAMPAIGN_INFO,
  SET_DRIVER_INFO,
  SET_CHAT_INFO,
  SET_USER_INFO,
  LOGOUT,
  SET_BRAND_INFO,
  SET_FLIGHT_INFO,
  SET_PAYMENT_METHOD_INFO,
} from "./authType";

// Load from localStorage
const savedAuth = JSON.parse(localStorage.getItem("authState") || "{}");

const initialState = {
  name: "",
  email: "",
  profilePicture: "",
  role: "",
  exp: null,
  error: false,
  success: false,
  loading: false,
  type: null,
  token: savedAuth?.token || null,
  businessType: null,
  operationType: null,
  sidebarCollapse: false,
  merchantId: savedAuth?.merchantId || null,
  shopId: savedAuth?.shopId || null,

  chatInfo: savedAuth?.chatInfo || {
    id: "",
    customerProfilePicture: "",
    customerName: "",
  },

  campaignInfo: savedAuth?.campaignInfo || {
    id: "",
    name: "",
    appsImg: "",
    webImg: "",
    status: null,
    type: "",
    campaignType: "",
  },

  merchantInfo: savedAuth?.merchantInfo || {
    id: "",
    name: "",
    balance: "",
    profilePicture: "",
    mobileNumber: "",
    email: "",
    state: "",
    status: "",
    merchantId: "",
  },

  shopInfo: savedAuth?.shopInfo || {
    id: "",
    name: "",
    type: "",
    mobileNumber: "",
    rating: null,
    logo: "",
    banner: "",
    status: "",
    hubId: "",
    deleted: "",
  },

  driverInfo: savedAuth?.driverInfo || {
    driverId: "",
    image: "",
    name: "",
    rating: null,
    balance: "",
    mobileNumber: "",
    status: "",
  },

  customerInfo: savedAuth?.customerInfo || {
    fullName: "",
    profilePicture: "",
    balance: "",
    rating: null,
    numberOfRating: null,
    mobileNumber: "",
    status: "",
    id: "",
  },

  brandInfo: savedAuth?.brandInfo || {
    id: "",
    name: "",
    type: "",
    logo: "",
    bannerImage: "",
    status: null,
  },
};

// Save to localStorage helper
const saveToLocalStorage = (state) => {
  localStorage.setItem("authState", JSON.stringify(state));
};

const authReducer = (state = initialState, action = { type: "", payload: {} }) => {
  let updatedState = { ...state };

  switch (action.type) {
    case LOGIN_REQUEST:
      updatedState.loading = true;
      break;

    case LOGIN_SUCCESS:
      updatedState = { ...state, ...action.payload, loading: false };
      saveToLocalStorage(updatedState);
      break;

    case LOGIN_LOADING:
      updatedState.loading = true;
      break;

    case SIDEBAR_COLLAPSE:
    case SET_SHOP_INFO:
    case SET_PAYMENT_METHOD_INFO:
    case SET_MERCHANT_INFO:
    case SET_CAMPAIGN_INFO:
    case SET_DRIVER_INFO:
    case SET_CHAT_INFO:
    case SET_USER_INFO:
    case SET_BRAND_INFO:
    case SET_FLIGHT_INFO:
      updatedState = { ...state, ...action.payload, loading: false };
      saveToLocalStorage(updatedState);
      break;

    case LOGOUT:
      updatedState = {
        ...initialState,
        token: null,
        merchantInfo: null,
        merchantId: null,
        shopInfo: null,
        shopId: null,
      };
      localStorage.removeItem("authState");
      break;

    default:
      return state;
  }

  return updatedState;
};

export default authReducer;
